<template>
  <a-menu-item key="6" @click="showReviewProjectUserModal">
    <EyeOutlined />&nbsp;名單預覽&nbsp;
  </a-menu-item>
  <a-modal v-model:open="isOpen" width="85%" title="已匯入專案 人員名單" 
      style="top: 30px; bottom: 30px;" :maskClosable="isMaskClosable">
    <template #footer>
      <a-button type="primary" @click="closeReviewProjectUser">關閉</a-button>
    </template>
    <a-table style="width: 100%;" :data-source="formState.projectUserData" :pagination="pagination"
        :columns="projectUserColumns" :loading="isLoading" @change="reloadProjectUserData">
        <template #title>
            <a-space>
                <a-tag :bordered="false" color="geekblue">專案編號</a-tag>{{ formState.projectNo }}
                <a-divider type="vertical"/>
                <a-tag :bordered="false" color="geekblue">專案名稱</a-tag>{{ formState.projectName }}
                <a-divider type="vertical"/>
                <a-tag :bordered="false" color="geekblue">客戶名稱</a-tag>{{ formState.companyName }}
            </a-space>
            <a-input-search v-model:value="formState.searchText" placeholder="輸入搜尋文字" 
                    @change="onSearchProjectUserChange" style="padding: 12px; width: 240px; float: right;" 
                    @search="onSearchProjectUser"/>
        </template>
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'personalNo'">
            {{ common.getDisplayPersonalNo(record.personalNo) }}
          </template>
          <template v-if="column.key === 'sex'">
            <template v-if="record.sex === 'Male'">
                <a-tag color="blue">
                  <ManOutlined />&nbsp;男性
                </a-tag>
            </template>
            <template v-else-if="record.sex === 'Female'">
                <a-tag color="error">
                  <WomanOutlined />&nbsp;女性
                </a-tag>
            </template>
          </template>
          <template v-else-if="column.key === 'birthday'">
            <template v-if="record.birthday != null">
              <CalendarOutlined />&nbsp;{{ record.birthday }}
            </template>
          </template>
          <template v-else-if="column.key === 'workStartDate'">
            <template v-if="record.workStartDate != null">
              <CalendarOutlined />&nbsp;{{ record.workStartDate }}
            </template>
          </template>
        </template>
    </a-table>
  </a-modal>
</template>
<script setup>
import { EyeOutlined, ManOutlined, WomanOutlined, CalendarOutlined } from "@ant-design/icons-vue";
import { ref, reactive, defineProps } from 'vue';

import common from "@/common";
import config from "@/config";

const props = defineProps(['project']);

const isOpen = ref(false);
const formState = reactive({});
const isMaskClosable = ref(false);
const isLoading = ref(false);
const pagination = reactive({
  current: 1
});

const projectUserColumns = [{
    title: "姓名",
    dataIndex: "name",
    key: "name",
    align: "left"
}, {
    title: "證件編號",
    dataIndex: "personalNo",
    key: "personalNo",
    align: "left"
}, {
    title: "健康編號",
    dataIndex: "healthNo",
    key: "healthNo",
    align: "left"
}, {
    title: "性別",
    dataIndex: "sex",
    key: "sex",
    align: "left",
    filters: [{
        text: "男性",
        value: "Male"
    }, {
        text: "女性",
        value: "Female"
    }]
}, {
    title: "生日",
    dataIndex: "birthday",
    key: "birthday",
    align: "left"
}, {
    title: "工號",
    dataIndex: "jobNo",
    key: "jobNo",
    align: "left"
}, {
    title: "到職日",
    dataIndex: "workStartDate",
    key: "workStartDate",
    align: "left"
}, {
    title: "公司名稱",
    dataIndex: "compName",
    key: "compName",
    align: "left"
}, {
    title: "單位名稱",
    dataIndex: "unitName",
    key: "unitName",
    align: "left"
}];

const reloadProjectUserData = (page, filters) => {
  pagination.current = page.current;
  pagination.pageSize = page.pageSize;
  filters.sex = filters.sex == null ? [] : filters.sex;
  if (filters.sex.toString() === formState.sexFilter.toString()) {
    return ;
  }
  formState.sexFilter = filters.sex;
  onSearchProjectUser();
}

const onSearchProjectUserChange = () => {
  if (common.isEmpty(formState.searchText)) {
    onSearchProjectUser();
  }
}

const onSearchProjectUser = () => {
  isLoading.value = true;
  common.postRequest(config.mgmtProjectUserEntities, {
    projectUrl: props.project.url,
    searchText: formState.searchText,
    sexFilter: formState.sexFilter
  }, (response) => {
    isLoading.value = false;
    formState.projectUserData = response.data;
    pagination.current = 1;
  }, () => {
    isLoading.value = false;
    formState.projectUserData = [];
    pagination.current = 1;
  });
}

const showReviewProjectUserModal = () => {
  isOpen.value = true;
  formState.projectNo = props.project.projectNo;
  formState.projectName = props.project.projectName;
  formState.companyName = props.project.companyName;
  formState.searchText = "";
  formState.sexFilter = [];
  formState.projectUserData = [];
  onSearchProjectUser();
};

const closeReviewProjectUser = () => {
  isOpen.value = false;
}
</script>
<style scoped>
button,
span {
  display: inline-flex;
  align-items: center;
}
</style>